{
  "INBOX_MGMT": {
    "HEADER": "Căsuțe",
    "DESCRIPTION": "A channel is the mode of communication your customer chooses to interact with you. An inbox is where you manage interactions for a specific channel. It can include communications from various sources such as email, live chat, and social media.",
    "LEARN_MORE": "Learn more about inboxes",
    "RECONNECT": {
      "BUTTON": "Reconectează",
      "FACEBOOK": "Conexiunea cu Facebook a expirat sau a fost revocată. Mesajele trimise paginii nu ajung în această căsuță, iar răspunsurile pot eșua. O persoană care administrează pagina de Facebook trebuie să dea clic pe Reconectează și să se autentifice în Facebook.",
      "INSTAGRAM": "Conexiunea cu Instagram a expirat sau a fost revocată. Mesajele trimise contului nu ajung în această căsuță, iar răspunsurile pot eșua. Dați clic pe Reconectează și autentificați-vă cu același cont de Instagram. Un alt cont creează o căsuță nouă.",
      "GOOGLE": "Conexiunea cu Google a expirat sau a fost revocată. E-mailurile noi nu ajung în această căsuță, iar răspunsurile pot eșua. Dați clic pe Reconectează și autentificați-vă în Google ca {email}.",
      "MICROSOFT": "Conexiunea cu Microsoft a expirat sau a fost revocată. E-mailurile noi nu ajung în această căsuță, iar răspunsurile pot eșua. Dați clic pe Reconectează și autentificați-vă în Microsoft ca {email}.",
      "ALLEGRO": "Conexiunea cu Allegro a expirat sau a fost revocată. Mesajele cumpărătorilor nu ajung în această căsuță, iar răspunsurile pot eșua. Dați clic pe Reconectează și autentificați-vă în Allegro ca vânzătorul {seller}. Un alt cont de vânzător creează o căsuță nouă.",
      "IMAP_LOGIN": "Serverul de e-mail respinge autentificarea IMAP {login}. E-mailurile noi nu ajung în această căsuță. Verificați utilizatorul și parola IMAP în fila {tab} și salvați-le. Continuăm să încercăm autentificarea, iar căsuța își revine imediat ce autentificarea funcționează.",
      "WHATSAPP": "Conexiunea la WhatsApp a expirat sau a fost revocată. Atașamentele de la clienți nu ajung în această căsuță, iar răspunsurile pot eșua. Faceți clic pe Reconectează, conectați-vă la Facebook și selectați din nou numărul {phone}."
    },
    "LIST": {
      "404": "Nu există căsuțe poștale atașate acestui cont.",
      "RECONNECT_REQUIRED": "Este necesară reconectarea"
    },
    "CREATE_FLOW": {
      "CHANNEL": {
        "TITLE": "Alege canalul",
        "BODY": "Alegeți serviciul pe care doriți să-l integrați cu chatul."
      },
      "INBOX": {
        "TITLE": "Crează căsuța",
        "BODY": "Autentifică-te cu contul tău și creează un inbox."
      },
      "AGENT": {
        "TITLE": "Adaugă Agent",
        "BODY": "Adaugă agenți la inbox-ul creat."
      },
      "FINISH": {
        "TITLE": "Voilà!",
        "BODY": "Toate setarile sunt facute!"
      }
    },
    "ADD": {
      "CHANNEL_NAME": {
        "LABEL": "Nume Inbox",
        "PLACEHOLDER": "Introduceți numele inboxului (de exemplu: Acme Inc)",
        "ERROR": "Vă rugăm să introduceți un nume valid de inbox"
      },
      "WEBSITE_NAME": {
        "LABEL": "Nume website",
        "PLACEHOLDER": "Introduceți numele website-ului dvs. (de exemplu: Acme Inc)"
      },
      "INTERNAL_NAME": {
        "LABEL": "Nume intern",
        "PLACEHOLDER": "Denumiți inbox-ul așa cum este afișat în acest dashboard",
        "ERROR": "Vă rugăm să introduceți un nume intern unic"
      },
      "FB": {
        "HELP": "PS: Prin conectare, vom avea acces doar la mesajele paginii tale. Nu vom putea accesa niciodată mesajele tale private.",
        "CHOOSE_PAGE": "Alege pagina",
        "CHOOSE_PLACEHOLDER": "Selectaţi o pagină din listă",
        "INBOX_NAME": "Nume Inbox",
        "ADD_NAME": "Adaugă un nume pentru inbox-ul tău",
        "PICK_NAME": "Pick a Name for your Inbox",
        "PICK_A_VALUE": "Alege o valoare",
        "CREATE_INBOX": "Creează inbox"
      },
      "INSTAGRAM": {
        "CONTINUE_WITH_INSTAGRAM": "Continuă cu Instagram",
        "CONNECT_YOUR_INSTAGRAM_PROFILE": "Conectați profilul dumneavoastră Instagram",
        "HELP": "Pentru a adăuga profilul dumneavoastră Instagram ca un canal, trebuie să vă autentificați profilul Instagram făcând clic pe „Continuă cu Instagram” ",
        "ERROR_MESSAGE": "A apărut o eroare la conectarea la Instagram, vă rugăm să încercați din nou",
        "ERROR_AUTH": "A apărut o eroare la conectarea la Instagram, vă rugăm să încercați din nou",
        "NEW_INBOX_SUGGESTION": "Acest cont Instagram a fost anterior legat la un alt inbox și a fost migrat aici. Toate mesajele noi vor apărea aici. Vechiul inbox nu va mai putea trimite sau primi mesaje pentru acest cont.",
        "DUPLICATE_INBOX_BANNER": "Acest cont Instagram a fost migrat la noul inbox de canal Instagram. Nu veți mai putea trimite/primi mesaje Instagram din acest inbox."
      },
      "TWITTER": {
        "HELP": "Pentru a vă adăuga profilul de Twitter ca si canal, trebuie să vă autentificați profilul de Twitter făcând clic pe \"Conectați-vă cu Twitter\" ",
        "ERROR_MESSAGE": "A existat o eroare de conectare la Twitter, vă rugăm să încercați din nou",
        "TWEETS": {
          "ENABLE": "Creați conversații din tweet-urile menționate"
        }
      },
      "WEBSITE_CHANNEL": {
        "TITLE": "Canal web",
        "DESC": "Creați un canal pentru site-ul dvs. și începeți să asigurati suportul clienților prin intermediul widget-ului nostru web.",
        "LOADING_MESSAGE": "Crearea canalului de suport pe site",
        "CHANNEL_AVATAR": {
          "LABEL": "Avatar canal"
        },
        "CHANNEL_WEBHOOK_URL": {
          "LABEL": "URL Webhook",
          "PLACEHOLDER": "Please enter your Webhook URL",
          "ERROR": "Te rog introdu un URL valid"
        },
        "CHANNEL_DOMAIN": {
          "LABEL": "Domeniu website",
          "PLACEHOLDER": "Introduceți domeniul website-ului (exemplu: acme.com)"
        },
        "CHANNEL_WELCOME_TITLE": {
          "LABEL": "Titlu de salut",
          "PLACEHOLDER": "Salut!"
        },
        "CHANNEL_WELCOME_TAGLINE": {
          "LABEL": "Tagline de Bun Venit",
          "PLACEHOLDER": "Noi facem conectarea cu noi simplă. Întreabă-ne orice, sau partajează-ți feedback-ul."
        },
        "CHANNEL_GREETING_MESSAGE": {
          "LABEL": "Mesaj de întâmpinare canal",
          "PLACEHOLDER": "De obicei, Acme Inc răspunde în câteva ore."
        },
        "CHANNEL_GREETING_TOGGLE": {
          "LABEL": "Activare salut canal",
          "HELP_TEXT": "Trimiteți automat mesaje de întâmpinare atunci când clienții încep o conversație și trimit primul lor mesaj.",
          "ENABLED": "Activat",
          "DISABLED": "Dezactivat"
        },
        "REPLY_TIME": {
          "TITLE": "Setarea orei de răspuns",
          "IN_A_FEW_MINUTES": "În câteva minute",
          "IN_A_FEW_HOURS": "În câteva ore",
          "IN_A_DAY": "Într-o zi",
          "HELP_TEXT": "Acest timp de răspuns va fi afișat pe widget-ul de chat live"
        },
        "WIDGET_COLOR": {
          "LABEL": "Culoare widget",
          "PLACEHOLDER": "Actualizează culoarea folosită în widget"
        },
        "SUBMIT_BUTTON": "Crează inbox",
        "API": {
          "ERROR_MESSAGE": "Nu am reușit să creăm un canal de site web, vă rugăm să încercați din nou"
        }
      },
      "TWILIO": {
        "TITLE": "Twilio SMS/Canal WhatsApp",
        "DESC": "Integrați Twilio și începeți să vă sprijiniți clienții prin SMS sau WhatsApp.",
        "ACCOUNT_SID": {
          "LABEL": "Cont SID",
          "PLACEHOLDER": "Te rugăm să introduci ID-ul contului Twilio",
          "ERROR": "Acest câmp este obligatoriu"
        },
        "API_KEY": {
          "USE_API_KEY": "Use API Key Authentication",
          "LABEL": "API Key SID",
          "PLACEHOLDER": "Please enter your API Key SID",
          "ERROR": "Acest câmp este obligatoriu"
        },
        "API_KEY_SECRET": {
          "LABEL": "API Key Secret",
          "PLACEHOLDER": "Please enter your API Key Secret",
          "ERROR": "Acest câmp este obligatoriu"
        },
        "MESSAGING_SERVICE_SID": {
          "LABEL": "Serviciul de mesagerie SID",
          "PLACEHOLDER": "Vă rugăm să introduceți Twilio Messaging Service SID",
          "ERROR": "Acest câmp este obligatoriu",
          "USE_MESSAGING_SERVICE": "Utilizați un serviciu de mesagerie Twilio"
        },
        "CHANNEL_TYPE": {
          "LABEL": "Tipul canalului",
          "ERROR": "Vă rugăm să selectaţi tipul canalului"
        },
        "AUTH_TOKEN": {
          "LABEL": "Token de autentificare",
          "PLACEHOLDER": "Te rugăm să introduci tokenul Twilio Auth",
          "ERROR": "Acest câmp este obligatoriu"
        },
        "CHANNEL_NAME": {
          "LABEL": "Nume Inbox",
          "PLACEHOLDER": "Vă rugăm să introduceți un nume de inbox",
          "ERROR": "Acest câmp este obligatoriu"
        },
        "PHONE_NUMBER": {
          "LABEL": "Număr de telefon",
          "PLACEHOLDER": "Introduceți numărul de telefon de la care va fi trimis mesajul.",
          "ERROR": "Vă rugăm să furnizați un număr de telefon valid care începe cu semnul \"+\" și nu conține spații."
        },
        "API_CALLBACK": {
          "TITLE": "Callback URL",
          "SUBTITLE": "Trebuie să configurați URL-ul de callback al mesajelor în Twilio cu adresa URL menționată aici."
        },
        "SUBMIT_BUTTON": "Crează canal Twilio",
        "API": {
          "ERROR_MESSAGE": "Nu am putut autentifica credentialele Twilio, încercați din nou"
        }
      },
      "SMS": {
        "TITLE": "Canal SMS",
        "DESC": "Începeți să vă sprijiniți clienții prin SMS.",
        "PROVIDERS": {
          "LABEL": "Furnizor API",
          "TWILIO": "Twilio",
          "BANDWIDTH": "Banda",
          "SMS_BRANA": "SMS Brana",
          "DIDWW": "DIDWW"
        },
        "API": {
          "ERROR_MESSAGE": "Nu am reușit să salvăm canalul SMS"
        },
        "BANDWIDTH": {
          "ACCOUNT_ID": {
            "LABEL": "ID cont",
            "PLACEHOLDER": "Vă rugăm să introduceți ID-ul contului de lățime de bandă",
            "ERROR": "Acest câmp este obligatoriu"
          },
          "API_KEY": {
            "LABEL": "Cheie API",
            "PLACEHOLDER": "Please enter your Bandwidth API Key",
            "ERROR": "Acest câmp este obligatoriu"
          },
          "API_SECRET": {
            "LABEL": "API secret",
            "PLACEHOLDER": "Please enter your Bandwidth API Secret",
            "ERROR": "Acest câmp este obligatoriu"
          },
          "APPLICATION_ID": {
            "LABEL": "ID Aplicaţie",
            "PLACEHOLDER": "Vă rugăm să introduceți ID-ul aplicației lățimea de bandă",
            "ERROR": "Acest câmp este obligatoriu"
          },
          "INBOX_NAME": {
            "LABEL": "Nume Inbox",
            "PLACEHOLDER": "Vă rugăm să introduceți un nume de inbox",
            "ERROR": "Acest câmp este obligatoriu"
          },
          "PHONE_NUMBER": {
            "LABEL": "Număr de telefon",
            "PLACEHOLDER": "Introduceți numărul de telefon de la care va fi trimis mesajul.",
            "ERROR": "Vă rugăm să furnizați un număr de telefon valid care începe cu semnul \"+\" și nu conține spații."
          },
          "SUBMIT_BUTTON": "Creați un canal de lățime de bandă",
          "API": {
            "ERROR_MESSAGE": "Nu am reușit să autentificăm acreditările de lățime de bandă, vă rugăm să încercați din nou"
          },
          "API_CALLBACK": {
            "TITLE": "Callback URL",
            "SUBTITLE": "Trebuie să configurați URL-ul de apelare inversă a mesajului în Lățime de bandă cu URL-ul menționat aici."
          }
        },
        "SMS_BRANA": {
          "INBOX_NAME": {
            "LABEL": "Nume inbox",
            "PLACEHOLDER": "Vă rugăm să introduceți un nume pentru inbox",
            "ERROR": "Acest câmp este obligatoriu"
          },
          "PHONE_NUMBER": {
            "LABEL": "Număr de telefon",
            "PLACEHOLDER": "Vă rugăm să introduceți numărul de telefon de la care vor fi trimise mesajele.",
            "ERROR": "Vă rugăm să furnizați un număr de telefon valid care începe cu un semn `+`."
          },
          "SUBMIT_BUTTON": "Creează canal SMS Brana",
          "API": {
            "ERROR_MESSAGE": "Nu am putut crea canalul SMS Brana"
          }
        },
        "DIDWW": {
          "INBOX_NAME": {
            "LABEL": "Nume inbox",
            "PLACEHOLDER": "Vă rugăm să introduceți un nume pentru inbox",
            "ERROR": "Acest câmp este obligatoriu"
          },
          "PHONE_NUMBER": {
            "LABEL": "Număr de telefon",
            "PLACEHOLDER": "Vă rugăm să introduceți numărul de telefon de la care vor fi trimise mesajele.",
            "ERROR": "Vă rugăm să furnizați un număr de telefon valid care începe cu un semn `+`."
          },
          "SUBMIT_BUTTON": "Creează canal DIDWW",
          "API": {
            "ERROR_MESSAGE": "Nu am putut crea canalul DIDWW"
          }
        }
      },
      "WHATSAPP": {
        "PROVIDERS": {
          "LABEL": "Furnizor API",
          "WHATSAPP_CLOUD": "WhatsApp Cloud"
        },
        "API_CALLBACK": {
          "SUBTITLE": "Trebuie să configurezi adresa URL webhook și simbolul de verificare în portalul Facebook pentru dezvoltatori cu valorile afișate mai jos.",
          "WEBHOOK_URL": "URL Webhook",
          "WEBHOOK_VERIFICATION_TOKEN": "Token de verificare Webhook"
        },
        "EMBEDDED_SIGNUP": {
          "TITLE": "Configurare rapidă cu Meta",
          "DESC": "Veți fi redirecționat către Meta pentru a vă conecta la contul WhatsApp Business. Accesul de administrator va face configurarea mai simplă.",
          "BENEFITS": {
            "EASY_SETUP": "Nu necesită configurare manuală",
            "SECURE_AUTH": "Autentificare securizată bazată pe OAuth",
            "AUTO_CONFIG": "Configurare automată a webhook-ului și a numărului de telefon"
          },
          "SUBMIT_BUTTON": "Conectează-te cu WhatsApp Business",
          "AUTH_PROCESSING": "Se autentifică cu Meta",
          "WAITING_FOR_BUSINESS_INFO": "Finalizați configurarea afacerii în fereastra Meta...",
          "PROCESSING": "Se configurează contul WhatsApp Business",
          "CANCELLED": "Înregistrarea WhatsApp a fost anulată",
          "WAITING_FOR_AUTH": "Se așteaptă autentificarea...",
          "INVALID_BUSINESS_DATA": "Date de afacere nevalide primite de la Facebook. Încercați din nou.",
          "SIGNUP_ERROR": "A apărut o eroare la înregistrare",
          "SDK_LOAD_ERROR": "SDK-ul Facebook nu a putut fi încărcat. Încercați din nou.",
          "AUTH_NOT_COMPLETED": "Autentificarea nu a fost finalizată. Reporniți procesul.",
          "SUCCESS_FALLBACK": "Contul WhatsApp Business a fost configurat cu succes",
          "RECONNECTED": "Canalul WhatsApp a fost reconectat cu succes"
        },
        "API": {
          "ERROR_MESSAGE": "Nu am reușit să salvăm canalul WhatsApp"
        }
      },
      "API_CHANNEL": {
        "TITLE": "Canal API",
        "DESC": "Integrați-vă cu canalul API și începeți să vă sprijiniți clienții.",
        "CHANNEL_NAME": {
          "LABEL": "Nume canal",
          "PLACEHOLDER": "Te rugăm să introduci un conținut",
          "ERROR": "Acest câmp este obligatoriu"
        },
        "WEBHOOK_URL": {
          "LABEL": "URL Webhook",
          "SUBTITLE": "Configure the URL where you want to receive callbacks on events.",
          "PLACEHOLDER": "URL Webhook"
        },
        "SUBMIT_BUTTON": "Creare canal API",
        "API": {
          "ERROR_MESSAGE": "Nu am putut salva canalul API"
        }
      },
      "SALESFORCE_CHANNEL": {
        "TITLE": "Canal Salesforce",
        "DESC": "Integrați cu canalul Salesforce și începeți să vă sprijiniți clienții.",
        "CHANNEL_NAME": {
          "LABEL": "Nume canal",
          "PLACEHOLDER": "Vă rugăm să introduceți un nume pentru canal",
          "ERROR": "Acest câmp este obligatoriu"
        },
        "API_BASE_URL": {
          "LABEL": "URL API Salesforce",
          "SUBTITLE": "Configurați URL-ul de bază pentru instanța dumneavoastră Salesforce.",
          "PLACEHOLDER": "URL API Salesforce",
          "ERROR": "Acest câmp este obligatoriu"
        },
        "KEY_ID": {
          "LABEL": "Key ID",
          "SUBTITLE": "Key ID pentru canalul dumneavoastră Salesforce.",
          "PLACEHOLDER": "KEY ID",
          "ERROR": "Acest câmp este obligatoriu"
        },
        "SECRET": {
          "LABEL": "Secret",
          "SUBTITLE": "Secret pentru canalul dumneavoastră Salesforce.",
          "PLACEHOLDER": "*****",
          "ERROR": "Acest câmp este obligatoriu"
        },
        "SUBMIT_BUTTON": "Creează canal Salesforce",
        "API": {
          "ERROR_MESSAGE": "Nu am putut salva canalul Salesforce"
        },
        "API_CALLBACK": {
          "TITLE": "URL webhook",
          "SUBTITLE": "Trebuie să configurați URL-ul webhook în Salesforce cu URL-ul menționat aici."
        },
        "BEARER_TOKEN": {
          "TITLE": "Bearer Token",
          "SUBTITLE": "Folosiți acest bearer token pentru autentificare atunci când configurați webhook-ul în Salesforce."
        },
        "OVERRIDE_EMAIL_SENDER": {
          "TITLE": "Suprascrie expeditor email",
          "SUBTITLE": "Dacă este setată, această adresă de email va fi folosită ca expeditor pentru toate emailurile trimise în locul emailului sursă al conversației.",
          "PLACEHOLDER": "de ex. support{'@'}example.com"
        }
      },
      "ALLEGRO_CHANNEL": {
        "TITLE": "Canal Allegro",
        "DESC": "Conectați un cont de vânzător Allegro și răspundeți din centrul de contact la mesajele din centrul său de mesaje.",
        "CHANNEL_NAME": {
          "LABEL": "Nume inbox",
          "SUBTITLE": "Numele pe care agenții îl văd pentru acest inbox.",
          "PLACEHOLDER": "Introduceți un nume de inbox",
          "ERROR": "Acest câmp este obligatoriu"
        },
        "SUBMIT_BUTTON": "Autentificare cu Allegro",
        "API": {
          "ERROR_MESSAGE": "A apărut o eroare la conectarea la Allegro, vă rugăm să încercați din nou"
        },
        "SELLER_LOGIN": {
          "TITLE": "Autentificare Allegro",
          "SUBTITLE": "Contul de vânzător pentru care acest inbox citește și răspunde la mesaje."
        }
      },
      "KAUFLAND_CHANNEL": {
        "TITLE": "Canal Kaufland",
        "DESC": "Răspundeți la mesajele din tichetele pe care cumpărătorii vi le trimit pe marketplace-ul Kaufland.",
        "CHANNEL_NAME": {
          "LABEL": "Nume canal",
          "PLACEHOLDER": "Vă rugăm să introduceți un nume pentru canal",
          "ERROR": "Acest câmp este obligatoriu"
        },
        "CLIENT_KEY": {
          "LABEL": "Client Key",
          "SUBTITLE": "Client Key de 32 de caractere din pagina de setări API a contului dumneavoastră de vânzător Kaufland.",
          "PLACEHOLDER": "cheie de 32 de caractere",
          "ERROR": "Introduceți Client Key de 32 de caractere"
        },
        "SECRET_KEY": {
          "LABEL": "Secret Key",
          "SUBTITLE": "Secret Key de 64 de caractere care aparține cheii Client Key. Kaufland îl afișează o singură dată și nu este trimis niciodată înapoi pe această pagină.",
          "PLACEHOLDER": "cheie de 64 de caractere",
          "ERROR": "Introduceți Secret Key de 64 de caractere"
        },
        "SUBMIT_BUTTON": "Creează canal Kaufland",
        "API": {
          "ERROR_MESSAGE": "Nu am putut salva canalul Kaufland"
        },
        "DISCONNECTED": {
          "TITLE": "Deconectat",
          "MESSAGE": "Kaufland a respins aceste chei API. Introduceți din nou Client Key și Secret Key pentru a reconecta acest inbox."
        }
      },
      "EMAIL_CHANNEL": {
        "TITLE": "Canal de e-mail",
        "DESC": "Integrate your email inbox.",
        "CHANNEL_NAME": {
          "LABEL": "Nume canal",
          "PLACEHOLDER": "Te rugăm să introduci un conținut",
          "ERROR": "Acest câmp este obligatoriu"
        },
        "EMAIL": {
          "LABEL": "Email",
          "SUBTITLE": "Furnizați adresa de e-mail la care clienții trimit solicitări de asistență.",
          "PLACEHOLDER": "Email"
        },
        "SUBMIT_BUTTON": "Creare canal Email",
        "API": {
          "ERROR_MESSAGE": "Nu am putut salva canalul de email"
        },
        "FINISH_MESSAGE": "Începeți să vă trimiteți e-mailuri la următoarea adresă de e-mail."
      },
      "LINE_CHANNEL": {
        "TITLE": "Canal LINE",
        "DESC": "Integrați-vă cu canalul LINE și începeți să vă sprijiniți clienții.",
        "CHANNEL_NAME": {
          "LABEL": "Nume canal",
          "PLACEHOLDER": "Te rugăm să introduci un conținut",
          "ERROR": "Acest câmp este obligatoriu"
        },
        "LINE_CHANNEL_ID": {
          "LABEL": "ID-ul canalului LINE",
          "PLACEHOLDER": "ID-ul canalului LINE"
        },
        "LINE_CHANNEL_SECRET": {
          "LABEL": "Secret canal LINE",
          "PLACEHOLDER": "Secret canal LINE"
        },
        "LINE_CHANNEL_TOKEN": {
          "LABEL": "Token canal LINE",
          "PLACEHOLDER": "Token canal LINE"
        },
        "SUBMIT_BUTTON": "Crearea canalului LINE",
        "API": {
          "ERROR_MESSAGE": "Nu am reușit să salvăm canalul LINE"
        },
        "API_CALLBACK": {
          "TITLE": "Callback URL",
          "SUBTITLE": "Trebuie să configurați URL-ul webhook în aplicația LINE cu URL-ul menționat aici."
        }
      },
      "TELEGRAM_CHANNEL": {
        "TITLE": "Canal Telegram",
        "DESC": "Integrați-vă cu canalul Telegram și începeți să vă sprijiniți clienții.",
        "BOT_TOKEN": {
          "LABEL": "Token de bot",
          "SUBTITLE": "Configurați simbolul bot pe care l-ați obținut de la Telegram BotFather.",
          "PLACEHOLDER": "Token de bot"
        },
        "SUBMIT_BUTTON": "Creați canal Telegram",
        "API": {
          "ERROR_MESSAGE": "Nu am reușit să salvăm canalul de telegramă"
        }
      },
      "PHONE_CHANNEL": {
        "TITLE": "Apeluri telefonice",
        "DESC": "Configurați care apeluri telefonice vor apărea sub acest inbox.",
        "NAME": {
          "LABEL": "Nume inbox",
          "SUBTITLE": "Alegeți un nume ușor de identificat."
        },
        "PHONE_NUMBER": {
          "LABEL": "Număr de telefon",
          "SUBTITLE": "Introduceți numerele de telefon care aparțin acestui inbox, puteți adăuga mai multe numere ulterior.",
          "PLACEHOLDER": "+421123908635"
        },
        "SUBMIT_BUTTON": "Creează inbox pentru apeluri telefonice",
        "API": {
          "ERROR_MESSAGE": "Nu am putut crea inbox-ul"
        }
      },
      "AUTH": {
        "TITLE": "Alege un canal",
        "DESC": "Chatul acceptă widget-uri live-chat, Facebook Messenger, WhatsApp, e-mailuri etc., ca canale. Dacă doriți să construiți un canal personalizat, îl puteți crea folosind canalul API. Pentru a începe, alegeți unul dintre canalele de mai jos."
      },
      "AGENTS": {
        "TITLE": "Agenți",
        "DESC": "Aici puteți adăuga agenți care să gestioneze inboxul nou creat. Numai acești agenți selectați vor avea acces la căsuța poștală. Agenții care nu fac parte din această căsuță poștală nu vor putea vedea sau răspunde la mesajele din această căsuță atunci când se autentifică. <br> <b>PS:</b> În calitate de administrator, dacă aveţi nevoie de acces la toate mesajele, ar trebui să vă adăugați ca agent la toate cutiile de mesaje pe care le creați.",
        "VALIDATION_ERROR": "Add at least one agent to your new Inbox",
        "PICK_AGENTS": "Alegerea agenților pentru inbox"
      },
      "DETAILS": {
        "TITLE": "Detalii inbox",
        "DESC": "Din meniul derulant de mai jos, selectați pagina Facebook pe care doriți să o conectați la chat. Poți de asemenea să dai un nume personalizat inbox-ului pentru o mai bună identificare."
      },
      "FINISH": {
        "TITLE": "Corect!",
        "DESC": "Ai reușit să integrezi pagina ta de Facebook cu chatul. Data viitoare când un client trimite un mesaj paginii tale, conversația va apărea automat pe căsuța ta poștală.<br>Vă oferim și un script de widget pe care îl puteți adăuga cu ușurință la site-ul dvs. Odată ce aceasta este în direct pe site-ul tău, clienții vă pot trimite mesaje direct de pe site-ul dvs fără ajutorul niciunui instrument extern și conversația va apărea aici, în chat.<br>Cool, nu? Păi, sigur că încercăm să fim :)"
      },
      "EMAIL_PROVIDER": {
        "TITLE": "Selectați furnizorul de e-mail",
        "DESCRIPTION": "Selectați un furnizor de e-mail din lista de mai jos. Dacă nu vedeți furnizorul de e-mail în listă, puteți selecta opțiunea celuilalt furnizor și furniza acreditările IMAP și SMTP."
      },
      "MICROSOFT": {
        "TITLE": "E-mail Microsoft",
        "DESCRIPTION": "Faceți clic pe butonul Conectare cu Microsoft pentru a începe. Veți redirecționa către pagina de conectare la e-mail. După ce acceptați permisiunile solicitate, veți fi redirecționat înapoi la pasul de creare a inboxului.",
        "EMAIL_PLACEHOLDER": "Introdu adresa de e-mail",
        "SIGN_IN": "Sign in with Microsoft",
        "ERROR_MESSAGE": "A existat o eroare la conectarea la Microsoft, încercați din nou"
      },
      "GOOGLE": {
        "TITLE": "Google Email",
        "DESCRIPTION": "Click on the Sign in with Google button to get started. You will redirected to the email sign in page. Once you accept the requested permissions, you would be redirected back to the inbox creation step.",
        "SIGN_IN": "Sign in with Google",
        "EMAIL_PLACEHOLDER": "Introdu adresa de e-mail",
        "ERROR_MESSAGE": "There was an error connecting to Google, please try again"
      }
    },
    "DETAILS": {
      "LOADING_FB": "Autentificare prin Facebook...",
      "ERROR_FB_LOADING": "Error loading Facebook SDK. Please disable any ad-blockers and try again from a different browser.",
      "ERROR_FB_AUTH": "Ceva nu a mers bine, reîmprospătați pagina...",
      "ERROR_FB_UNAUTHORIZED": "You're not authorized to perform this action. ",
      "ERROR_FB_UNAUTHORIZED_HELP": "Please ensure you have access to the Facebook page with full control. You can read more about Facebook roles <a href=\" https://www.facebook.com/help/187316341316631\">here</a>.",
      "ERROR_CHANNEL_CREATION": "Nu am reușit să creăm inbox-ul. Vă rugăm să încercați din nou.",
      "CREATING_CHANNEL": "Se creează inbox...",
      "TITLE": "Configurare detalii inbox",
      "DESC": ""
    },
    "AGENTS": {
      "BUTTON_TEXT": "Adaugă Agent",
      "ADD_AGENTS": "Adăugare agenți la inbox-ul dumneavoastra..."
    },
    "FINISH": {
      "TITLE": "Inbox-ul este gata!",
      "MESSAGE": "Acum poți intra în contact cu clienții tăi prin noul tău Canal. Suport fericit",
      "BUTTON_TEXT": "Du-mă acolo",
      "MORE_SETTINGS": "Mai multe setări",
      "WEBSITE_SUCCESS": "Ați finalizat cu succes crearea unui canal web. Copiați codul de mai jos și inserati-l pe site-ul dvs. Data viitoare când un client folosește conversația live, conversația va apărea automat pe căsuța poștală."
    },
    "REAUTH": "Reautorizează",
    "VIEW": "Vizualizare",
    "EDIT": {
      "API": {
        "SUCCESS_MESSAGE": "Setări Inbox actualizate cu succes",
        "AUTO_ASSIGNMENT_SUCCESS_MESSAGE": "Atribuire automată actualizată cu succes",
        "ERROR_MESSAGE": "Nu am putut actualiza setările inboxului. Încercați din nou mai târziu."
      },
      "EMAIL_COLLECT_BOX": {
        "ENABLED": "Activat",
        "DISABLED": "Dezactivat"
      },
      "ENABLE_CSAT": {
        "ENABLED": "Activat",
        "DISABLED": "Dezactivat"
      },
      "ENABLE_CSAT_ON_EACH_MESSAGE": {
        "ENABLED": "Activat",
        "DISABLED": "Dezactivat"
      },
      "SENDER_NAME_SECTION": {
        "TITLE": "Sender name",
        "SUB_TEXT": "Select the name shown to your customer when they receive emails from your agents.",
        "FOR_EG": "For eg:",
        "FRIENDLY": {
          "TITLE": "Amical",
          "FROM": "de la",
          "SUBTITLE": "Add the name of the agent who sent the reply in the sender name to make it friendly."
        },
        "PROFESSIONAL": {
          "TITLE": "Profesională",
          "SUBTITLE": "Use only the configured business name as the sender name in the email header."
        },
        "BUSINESS_NAME": {
          "BUTTON_TEXT": "+ Configure your business name",
          "PLACEHOLDER": "Enter your business name",
          "SAVE_BUTTON_TEXT": "Salvează"
        }
      },
      "ALLOW_MESSAGES_AFTER_RESOLVED": {
        "ENABLED": "Activat",
        "DISABLED": "Dezactivat"
      },
      "ENABLE_CONTINUITY_VIA_EMAIL": {
        "ENABLED": "Activat",
        "DISABLED": "Dezactivat"
      },
      "RESPOND_FROM_EMAIL": {
        "NONE": "Niciunul"
      },
      "SHOW_WELCOME_SCREEN": {
        "ENABLED": "Activat",
        "DISABLED": "Dezactivat"
      },
      "LOCK_TO_SINGLE_CONVERSATION": {
        "ENABLED": "Activat",
        "DISABLED": "Dezactivat"
      },
      "ENABLE_HMAC": {
        "LABEL": "Permite"
      },
      "FORCE_NEW_CONVERSATION_PER_LOAD": {
        "ENABLED": "Activat",
        "DISABLED": "Dezactivat"
      },
      "NEW_CONVERSATION_FORGETS_CONTACT": {
        "ENABLED": "Activat",
        "DISABLED": "Dezactivat"
      },
      "ENABLE_EMAIL_FETCHING": {
        "LABEL": "Activează sincronizarea emailurilor primite"
      },
      "ENABLE_CUSTOM_EMAIL": {
        "LABEL": "Activează domeniu de email personalizat (serviciu plătit)."
      },
      "ENABLE_FACEBOOK_COMMENTS": {
        "LABEL": "Activează procesarea comentariilor Facebook"
      },
      "SIGNATURE": {
        "TITLE": "Semnătură HTML",
        "SUB_TEXT": "Această semnătură va fi adăugată la subsolul fiecărui mesaj trimis din acest inbox.",
        "HTML_CONTENT": "Cod HTML",
        "HTML_CONTENT_HELP": "{'{{'}name{'}}'} va fi înlocuit cu numele agentului.\n{'{{'}email{'}}'} va fi înlocuit cu adresa de email a agentului care a trimis emailul.\n{'{{'}position{'}}'} va fi înlocuit cu poziția agentului.\n{'{{'}custom_line{'}}'} va fi înlocuit cu linia personalizată a agentului.\n{'{{'}email_signature_picture{'}}'} va fi înlocuit cu adresa URL a imaginii de semnătură email a agentului (nu cu o etichetă de imagine) — folosiți-o ca sursă de imagine (atributul src al unei etichete img).",
        "PREVIEW": "Previzualizare"
      },
      "COUNTRY_SIGNATURES": {
        "TITLE": "Semnături pe țări",
        "SUB_TEXT": "Un răspuns primește semnătura țării cumpărătorului.",
        "HELP": "Un răspuns este semnat în funcție de țara conversației: magazinul Kaufland, piața comenzii Allegro sau, în lipsă, limba în care scrie cumpărătorul. Când țara este necunoscută sau nu are aici o semnătură, se folosește semnătura HTML de mai sus. Piețele online interzic linkurile către site-ul dumneavoastră și datele de contact, așa că folosiți doar un salut și {'{{'}name{'}}'}.",
        "EMPTY": "Nu aveți încă semnături pe țări, așa că răspunsurile folosesc semnătura HTML de mai sus.",
        "COUNTRY": "Selectați o țară",
        "ADD": "Adaugă semnătură pe țară",
        "REMOVE": "Elimină"
      },
      "PHONE_DIALING_PREFIX": {
        "LABEL": "Prefix de apelare pentru numărul de telefon",
        "PLACEHOLDER": "Introduceți prefixul pentru rutarea corectă a apelurilor (de ex., *99)",
        "HELP_TEXT": "Acest prefix va fi adăugat automat în fața numerelor de telefon ale contactelor la apelarea din acest inbox."
      },
      "RESOLVE_LATER_TEXT": {
        "LABEL": "Textul butonului „rezolvăm mai târziu”",
        "PLACEHOLDER": "de ex. Vom rezolva acest subiect prin e-mail. Acum vreau să întreb despre altceva.",
        "HELP_TEXT": "Textul butonului din widget prin care vizitatorul părăsește subiectul curent și întreabă despre altceva. Dacă lăsați câmpul gol, se folosește textul implicit în limba vizitatorului."
      },
      "AUTO_SNOOZE_MINUTES": {
        "LABEL": "Amână automat apelurile ratate pentru X minute",
        "PLACEHOLDER": "0",
        "HELP_TEXT": "Amână automat apelurile ratate pentru numărul de minute specificat. Lăsați gol sau 0 pentru a dezactiva."
      },
      "AUTO_RESOLVE_AFTER_FAILED_ATTEMPTS": {
        "LABEL": "Rezolvă un apel ratat după X reapelări nereușite",
        "PLACEHOLDER": "0",
        "HELP_TEXT": "După ce un apel ratat a fost reapelat de X ori fără ca clientul să răspundă, acesta este rezolvat automat și se adaugă o notă privată. Lăsați gol sau 0 pentru a dezactiva."
      },
      "QUESTION_SUGGESTIONS": {
        "TITLE": "Sugestii de întrebări",
        "SUB_TEXT": "Configurați întrebări predefinite pe care clienții le pot folosi pentru a interacționa cu agenții dumneavoastră.",
        "QUESTIONS_LABEL": "Întrebări",
        "ADD_QUESTION": "Adaugă întrebare",
        "QUESTION": "Întrebare",
        "REMOVE": "Elimină",
        "QUESTION_TEXT": "Text afișat în bulă.",
        "QUESTION_TEXT_PLACEHOLDER": "Obligatoriu",
        "QUESTION_PAYLOAD": "Text trimis la clic.",
        "QUESTION_PAYLOAD_PLACEHOLDER": "Opțional",
        "SAVE": "Salvează",
        "NO_BOT_MESSAGE": "Pentru a genera sugestii AI suplimentare, vă rugăm să conectați un bot.",
        "BOT_CONNECTED_MESSAGE": "Sugestiile AI de întrebări de la bot pot fi activate în",
        "BOT_SETTINGS_LINK": "setările sale"
      },
      "ALTERNATIVE_EMAILS": {
        "TITLE": "E-mailuri alternative",
        "SUB_TEXT": "Adrese suplimentare pe care această căsuță de e-mail ar trebui să le trateze ca fiind ale sale la primirea e-mailurilor redirecționate.",
        "PLACEHOLDER": "alias{'@'}example.com",
        "ADD": "Adaugă",
        "REMOVE": "Elimină",
        "EMPTY": "Niciun e-mail alternativ configurat.",
        "HELP_TEXT": "Când un e-mail sosește cu una dintre aceste adrese ca destinatar, răspunsurile vor fi trimise cu aceeași adresă ca expeditor. Asigură-te că serverul tău SMTP de ieșire permite trimiterea de la aceste adrese.",
        "SIGNATURE_LABEL": "Semnătură",
        "PRIMARY_SIGNATURE": "Principală (implicită)"
      },
      "ADDITIONAL_SIGNATURES": {
        "TITLE": "Semnături suplimentare",
        "SUB_TEXT": "Definiți aici semnături suplimentare, apoi atribuiți-le e-mailurilor alternative de mai jos.",
        "OPTION": "Semnătură {number}",
        "ADD": "Adaugă semnătură",
        "REMOVE": "Elimină",
        "HELP_TEXT": "Când un răspuns este trimis de la un e-mail alternativ, se folosește semnătura atribuită acestuia în locul semnăturii căsuței de e-mail. E-mailurile alternative lăsate pe „Principală (implicită)” folosesc semnătura căsuței de e-mail."
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Şterge",
      "AVATAR_DELETE_BUTTON_TEXT": "Șterge avatarul",
      "DELETE_REQUESTED_TOOLTIP": "Acest inbox este marcat pentru ștergere",
      "RESTORE_BUTTON_TEXT": "Restaurează",
      "CONFIRM": {
        "TITLE": "Confirmă ștergerea",
        "MESSAGE": "Sigur doriți să ștergeți ",
        "PLACE_HOLDER": "Vă rugăm să tastați {inboxName} pentru a confirma",
        "YES": "Da, șterge ",
        "NO": "Nu, păstreaza "
      },
      "API": {
        "SUCCESS_MESSAGE": "Inbox șters cu succes",
        "MARKED_FOR_DELETION_MESSAGE": "Inbox marcat pentru ștergere",
        "RESTORE_SUCCESS_MESSAGE": "Inbox restaurat cu succes",
        "ERROR_MESSAGE": "Nu s-a putut șterge inbox-ul. Vă rugăm să încercați din nou mai târziu.",
        "RESTORE_ERROR_MESSAGE": "Inbox-ul nu a putut fi restaurat. Vă rugăm să încercați din nou mai târziu.",
        "AVATAR_SUCCESS_MESSAGE": "Avatar inbox șters cu succes",
        "AVATAR_ERROR_MESSAGE": "Nu s-a putut șterge avatarul inboxului. Încercați din nou mai târziu."
      }
    },
    "TABS": {
      "SETTINGS": "Setări",
      "COLLABORATORS": "Colaboratori",
      "AUTOMATIC_PRIORITY": "Prioritate automată",
      "AUTOMATIC_LABELING": "Etichetare automată",
      "CONFIGURATION": "Configurare",
      "CAMPAIGN": "Campanii",
      "PRE_CHAT_FORM": "Formular pre chat",
      "BUSINESS_HOURS": "Program de lucru",
      "WIDGET_BUILDER": "Widget Builder",
      "BOT_CONFIGURATION": "Configurarea botului",
      "SLA": "SLA"
    },
    "SETTINGS": "Setări",
    "FEATURES": {
      "LABEL": "Caracteristici",
      "DISPLAY_FILE_PICKER": "Afișarea selectorului de fișiere pe widget",
      "DISPLAY_EMOJI_PICKER": "Afișarea selectorului de emoji pe widget",
      "ALLOW_END_CONVERSATION": "Permite utilizatorilor să încheie conversația din widget",
      "SHOW_START_NEW_CONVERSATION_BUTTON": "Afișează butonul „Începe o conversație nouă” în antetul widgetului",
      "HIDE_INPUT_UNDER_START_NEW_CONVERSATION_BUTTON": "Ascunde câmpul de introducere când butonul „Începe o conversație nouă“ este afișat",
      "SHOW_HANDOFF_BUTTON": "Afișează butonul „Transferă către operator” în antetul widgetului",
      "USE_INBOX_AVATAR_FOR_BOT": "Utilizați numele inboxului și avatarul pentru bot",
      "ALLOW_OFFLINE_REPLY": "Permite agenților să trimită mesaje când contactul este offline și continuitatea pe email nu este disponibilă",
      "AUTO_CLOSE_OLD": "Marchează toate apelurile anterioare de la același număr ca rezolvate după rezolvarea unuia",
      "AUTO_ASSIGN_MISSED_ON_OUTGOING": "Atribuie automat apelurile ratate la efectuarea unui apel"
    },
    "SETTINGS_POPUP": {
      "MESSENGER_HEADING": "Script Messenger",
      "MESSENGER_SUB_HEAD": "Plasează acest buton în interiorul interiorul paginii web",
      "INBOX_AGENTS": "Agenți",
      "INBOX_TEAMS": "Echipe",
      "INBOX_COOPERATORS": "Colaboratori",
      "SELECT_PLACEHOLDER": "Selectați",
      "AGENTS_OR_TEAMS_INFO": "Puteți atribui fie agenți, fie echipe - nu ambele simultan.",
      "AGENT_ASSIGNMENT": "Atribuirea conversației",
      "AGENT_ASSIGNMENT_SUB_TEXT": "Actualizarea setărilor de atribuire a conversațiilor",
      "UPDATE": "Actualizare",
      "ENABLE_EMAIL_COLLECT_BOX": "Caseta Activare colectare e-mail",
      "ENABLE_EMAIL_COLLECT_BOX_SUB_TEXT": "Caseta Activarea sau dezactivarea colectării e-mailurilor în conversația nouă",
      "AUTO_ASSIGNMENT": "Activare atribuire automată",
      "ENABLE_CSAT": "Activați CSAT",
      "ENABLE_CSAT_ON_EACH_MESSAGE": "Activează CSAT la fiecare mesaj",
      "SENDER_NAME_SECTION": "Enable Agent Name in Email",
      "ENABLE_CSAT_SUB_TEXT": "Activați/dezactivați sondajul CSAT (Satisfacția clienților) după rezolvarea unei conversații",
      "ENABLE_CSAT_ON_EACH_MESSAGE_SUB_TEXT": "Activează/Dezactivează opțiunea de sondaj CSAT pentru fiecare mesaj trimis de agenți",
      "SENDER_NAME_SECTION_TEXT": "Enable/Disable showing Agent's name in email, if disabled it will show business name",
      "ENABLE_CONTINUITY_VIA_EMAIL": "Activați continuitatea conversației prin e-mail",
      "ENABLE_CONTINUITY_VIA_EMAIL_SUB_TEXT": "Conversațiile vor continua prin e-mail dacă adresa de e-mail de contact este disponibilă.",
      "RESPOND_FROM_EMAIL": "Răspunde din email",
      "RESPOND_FROM_EMAIL_SUB_TEXT_WEBWIDGET": "Emailurile către client — atât răspunsurile, cât și transcrierile conversațiilor — sunt trimise folosind setările SMTP ale inboxului de email selectat, de la adresa selectată (adresa proprie a inboxului sau unul dintre aliasurile acestuia), iar răspunsurile clientului ajung înapoi prin adresa sa IMAP.",
      "RESPOND_FROM_EMAIL_SUB_TEXT_OTHER": "Transcrierile conversațiilor sunt trimise folosind setările SMTP ale inboxului de email selectat, de la adresa selectată (adresa proprie a inboxului sau unul dintre aliasurile acestuia), iar răspunsurile ajung înapoi prin adresa sa IMAP.",
      "SHOW_WELCOME_SCREEN": "Afișează ecranul de întâmpinare",
      "SHOW_WELCOME_SCREEN_TOOLTIP": "Afișează ecranul de întâmpinare când este deschis widget-ul. Dacă este dezactivat, widget-ul va merge direct la vizualizarea conversației.",
      "AUTO_CLOSE_PENDING": "Rezolvă automat chaturile AI după (ore)",
      "AUTO_CLOSE_PENDING_SUB_TEXT": "Rezolvă automat chaturile AI după X ore de inactivitate.",
      "LOCK_TO_SINGLE_CONVERSATION": "Blocarea la o singură conversație",
      "LOCK_TO_SINGLE_CONVERSATION_SUB_TEXT": "Activarea sau dezactivarea mai multor conversații pentru aceeași persoană de contact în acest inbox",
      "INBOX_UPDATE_TITLE": "Setări Inbox",
      "INBOX_UPDATE_SUB_TEXT": "Actualizează setările de inbox",
      "AUTO_ASSIGNMENT_SUB_TEXT": "Activează sau dezactivează atribuirea automată a conversațiilor noi la agenții adăugați la această căsuță poștală.",
      "HMAC_VERIFICATION": "Validarea identității utilizatorului",
      "HMAC_DESCRIPTION": "Cu această cheie puteți genera un token secret care poate fi utilizat pentru a verifica identitatea utilizatorilor dvs.",
      "HMAC_ROTATE": {
        "BUTTON": "Rotește cheia",
        "TITLE": "Rotiți cheia secretă?",
        "WARNING": "Cheia curentă este revocată în momentul în care o rotiți.",
        "WARNING_DETAIL": "Nu există o perioadă de suprapunere, iar cheia nu poate fi restaurată.",
        "IMPACT": "Serverele dvs. trebuie să semneze utilizatorii cu noua cheie. Oricine este semnat în continuare cu cheia veche nu trece verificarea. Dacă validarea identității este obligatorie, aceștia nu pot începe o conversație.",
        "CONFIRM": "Rotește cheia",
        "CANCEL": "Anulează",
        "SUCCESS": "Cheie secretă rotită cu succes",
        "ERROR": "Nu s-a putut roti cheia secretă, încercați din nou"
      },
      "HMAC_LINK_TO_DOCS": "Puteți citi mai multe aici.",
      "HMAC_MANDATORY_VERIFICATION": "Impuneți validarea identității utilizatorului",
      "HMAC_MANDATORY_DESCRIPTION": "Dacă este activată, solicitările care nu pot fi verificate vor fi respinse.",
      "FORCE_NEW_CONVERSATION_PER_LOAD_TITLE": "Forțează o conversație nouă la fiecare încărcare a widgetului",
      "FORCE_NEW_CONVERSATION_PER_LOAD_SUBTITLE": "Dacă este activat, deschiderea widgetului într-o filă sau fereastră nouă începe o conversație nouă.",
      "NEW_CONVERSATION_FORGETS_CONTACT_TITLE": "Uită contactul la începerea unei conversații noi",
      "NEW_CONVERSATION_FORGETS_CONTACT_SUBTITLE": "Dacă este dezactivat, o conversație nouă pornită din widget păstrează contactul anterior.",
      "INBOX_IDENTIFIER": "Identificator inbox",
      "INBOX_IDENTIFIER_SUB_TEXT": "Utilizați simbolul \"inbox_identifier\" afișat aici pentru a vă autentifica clienții API.",
      "FORWARD_EMAIL_TITLE": "Redirecționare către e-mail",
      "FORWARD_EMAIL_SUB_TEXT": "Începeți să vă trimiteți e-mailuri la următoarea adresă de e-mail.",
      "EMAIL_FETCHING_ENABLED_TITLE": "Sincronizare email",
      "EMAIL_FETCHING_ENABLED_DESCRIPTION": "Activează sincronizarea și descărcarea automată a emailurilor primite din acest inbox",
      "CUSTOM_EMAIL_ENABLED_TITLE": "Domeniu de email personalizat",
      "CUSTOM_EMAIL_ENABLED_DESCRIPTION": "Activează pentru a folosi un domeniu de email personalizat pentru emailurile trimise",
      "CUSTOM_EMAIL_ENABLED_LINK_TO_DOCS": "Puteți citi mai multe aici.",
      "FACEBOOK_COMMENTS_TITLE": "Comentarii Facebook",
      "ALLOW_MESSAGES_AFTER_RESOLVED": "Permiteți rezolvarea mesajelor după ce conversația a fost rezolvată",
      "ALLOW_MESSAGES_AFTER_RESOLVED_SUB_TEXT": "Permiteți utilizatorilor finali să trimită mesaje chiar și după rezolvarea conversației.",
      "WIDGET_STATUS_LABEL": "Stare widget",
      "WIDGET_STATUS_ENABLED": "Activat",
      "WIDGET_STATUS_BUSINESS_HOURS": "Activat în timpul programului de lucru",
      "WIDGET_STATUS_DISABLED": "Dezactivat",
      "WIDGET_STATUS_HELP_TEXT": "Controlați când widget-ul este afișat vizitatorilor de pe site-ul dumneavoastră",
      "UPDATE_PRE_CHAT_FORM_SETTINGS": "Actualizarea setărilor formularului pre-chat",
      "EXPLICIT_CSAT_LOCALE": "Limba pentru sondaj CSAT și email",
      "EXPLICIT_CSAT_LOCALE_SUB_TEXT": "Alegeți limba pentru toate emailurile către clienți, inclusiv sondajele CSAT, transcrierile conversațiilor și notificările prin email",
      "EXPLICIT_CSAT_LOCALE_INHERIT": "Moștenește din cont",
      "INBOX_AGENTS_SUB_TEXT": "Adaugă sau elimină agenți din acest inbox",
      "WHATSAPP_CONNECTION": {
        "TITLE": "Conexiune WhatsApp",
        "SUBTITLE": "Cum este conectată această căsuță la WhatsApp.",
        "PROVIDER": "Furnizor",
        "PROVIDER_VALUE": "WhatsApp Cloud API (Meta)",
        "EMBEDDED_SIGNUP": "Conectat prin înregistrarea integrată Meta",
        "STATUS": "Stare",
        "CONNECTED": "Conectat",
        "RECONNECT_HINT": "Faceți clic pe Reconectează în mesajul de mai sus.",
        "PHONE_NUMBER": "Număr de telefon",
        "BUSINESS_ACCOUNT": "ID cont WhatsApp Business",
        "OPEN_MANAGER": "Deschide în WhatsApp Manager",
        "PHONE_NUMBER_ID": "ID număr de telefon",
        "TEMPLATES": "Șabloane de mesaje",
        "TEMPLATES_COUNT": "{approved} din {total} aprobate",
        "TEMPLATES_SYNCED": "Ultima sincronizare: {date}",
        "TEMPLATES_NOT_SYNCED": "Încă nesincronizate",
        "MANAGE_TEMPLATES": "Gestionează șabloanele"
      }
    },
    "HELP_CENTER": {
      "LABEL": "Asistenta",
      "PLACEHOLDER": "Selectați Centrul de ajutor",
      "SELECT_PLACEHOLDER": "Selectați Centrul de ajutor",
      "REMOVE": "Eliminarea Centrului de ajutor",
      "SUB_TEXT": "Atașarea unui Centru de ajutor cu inboxul"
    },
    "AUTO_ASSIGNMENT": {
      "MAX_ASSIGNMENT_LIMIT": "Limita de atribuire automată",
      "MAX_ASSIGNMENT_LIMIT_RANGE_ERROR": "Vă rugăm să introduceți o valoare mai mare de 0",
      "MAX_ASSIGNMENT_LIMIT_SUB_TEXT": "Limitați numărul maxim de conversații din acest inbox care pot fi atribuite automat unui agent"
    },
    "SLA": {
      "TITLE": "Politici SLA",
      "SUB_TEXT": "Configurați timpii SLA de răspuns și rezolvare pentru fiecare nivel de prioritate a conversației.",
      "LOADING": "Se încarcă politicile SLA...",
      "FIELDS": {
        "ACTIVE": "Activ",
        "TICKET_PRIORITY": "Prioritate tichet",
        "FIRST_RESPONSE_TIME": "Timp primul răspuns",
        "EVERY_RESPONSE_TIME": "Timp fiecare răspuns",
        "RESOLUTION_TIME": "Timp de rezolvare",
        "PLACEHOLDER": "de ex. 1h 30m"
      },
      "API": {
        "SUCCESS_MESSAGE": "Politicile SLA au fost actualizate cu succes.",
        "ERROR_MESSAGE": "Politicile SLA nu au putut fi actualizate. Vă rugăm să încercați din nou."
      }
    },
    "AUTOMATIC_PRIORITY": {
      "TITLE": "Prioritate automată",
      "SUB_TEXT": "Configurați atribuirea automată a priorității în funcție de conținutul conversației.",
      "BILLING_DISCLAIMER": {
        "TITLE": "Notă de facturare",
        "MESSAGE": "Fiecare evaluare de prioritate va genera o taxă. Vă rugăm să consultați detaliile planului dumneavoastră pentru informații despre prețuri."
      },
      "MODE": {
        "OFF": "Dezactivat",
        "ALL_MESSAGES": "Activ pentru toate mesajele primite",
        "FIRST_MESSAGE": "Activ doar pentru primul mesaj primit"
      },
      "PRIORITY_LEVELS": {
        "TITLE": "Configurare niveluri de prioritate",
        "SUB_TEXT": "Configurați ce niveluri de prioritate ar trebui activate și descrierile acestora. Furnizați criterii clare pentru ca AI să determine când ar trebui atribuită această prioritate."
      },
      "DESCRIPTION_LABEL": "Descriere",
      "DESCRIPTION_PLACEHOLDER": "Descrieți conversațiile care trebuie marcate ca prioritate {priority}",
      "SET_AS_DEFAULT": "Setează ca prioritate implicită",
      "MULTIPLE_DEFAULTS_WARNING": "Doar un singur nivel de prioritate ar trebui setat ca implicit. Vă rugăm să debifați celelalte valori implicite."
    },
    "AUTOMATIC_LABELING": {
      "TITLE": "Etichetare automată",
      "SUB_TEXT": "Configurați atribuirea automată a etichetelor în funcție de conținutul conversației.",
      "BILLING_DISCLAIMER": {
        "TITLE": "Notă de facturare",
        "MESSAGE": "Fiecare evaluare de etichetare va genera o taxă. Vă rugăm să consultați detaliile planului dumneavoastră pentru informații despre prețuri."
      },
      "MODE": {
        "OFF": "Dezactivat",
        "CONVERSATION_OPEN": "La deschiderea conversației",
        "CONVERSATION_CLOSE": "La închiderea conversației",
        "ALL_MESSAGES": "La fiecare mesaj - indiferent de stare",
        "FIRST_MESSAGE": "La primul mesaj - indiferent de stare"
      },
      "LABEL_CONFIGURATION": {
        "TITLE": "Configurare etichete",
        "SUB_TEXT": "Configurați ce etichete ar trebui să fie disponibile pentru atribuire automată și descrierile acestora. Furnizați criterii clare pentru ca AI să determine când ar trebui aplicată această etichetă."
      },
      "DESCRIPTION_LABEL": "Descriere",
      "DESCRIPTION_PLACEHOLDER": "Descrieți conversațiile care trebuie etichetate ca {label}. Dacă lăsați acest câmp gol, se va folosi descrierea etichetei.",
      "NO_LABELS_MESSAGE": "Nicio etichetă găsită. Creați mai întâi etichete pentru a activa etichetarea automată.",
      "CREATE_LABELS_LINK": "Creați etichete"
    },
    "FACEBOOK_REAUTHORIZE": {
      "TITLE": "Reautorizează",
      "SUBTITLE": "Conexiunea ta de Facebook a expirat, te rugăm să-ți reconectezi pagina de Facebook pentru a continua serviciile",
      "MESSAGE_SUCCESS": "Reconectarea cu succes",
      "MESSAGE_ERROR": "A apărut o eroare, încercați din nou"
    },
    "PRE_CHAT_FORM": {
      "DESCRIPTION": "Formularele pre-chat vă permit să capturați informații despre utilizatori înainte de a începe conversația cu dvs.",
      "SET_FIELDS": "Câmpuri de formular pre-chat",
      "SET_FIELDS_HEADER": {
        "FIELDS": "Câmpuri",
        "LABEL": "Etichetă",
        "PLACE_HOLDER": "Înlocuitor",
        "KEY": "Cheie",
        "TYPE": "Tip",
        "REQUIRED": "Necesar"
      },
      "ENABLE": {
        "LABEL": "Activați formularul de pre chat",
        "OPTIONS": {
          "ENABLED": "Da",
          "DISABLED": "Nu"
        }
      },
      "PRE_CHAT_MESSAGE": {
        "LABEL": "Pre chat message",
        "PLACEHOLDER": "Acest mesaj ar fi vizibil pentru utilizatori împreună cu formularul"
      },
      "REQUIRE_EMAIL": {
        "LABEL": "Vizitatorii ar trebui să furnizeze numele și adresa lor de e-mail înainte de a începe chat-ul"
      }
    },
    "BUSINESS_HOURS": {
      "TITLE": "Setați-vă disponibilitatea",
      "SUBTITLE": "Setați-vă disponibilitatea pe widget-ul livechat",
      "WEEKLY_TITLE": "Setarea orelor săptămânale",
      "TIMEZONE_LABEL": "Selectați fusul orar",
      "UPDATE": "Actualizarea setărilor orelor de lucru",
      "TOGGLE_AVAILABILITY": "Activați disponibilitatea afacerii pentru acest inbox",
      "UNAVAILABLE_MESSAGE_LABEL": "Mesaj indisponibil pentru vizitatori",
      "TOGGLE_HELP": "Enabling business availability will show the available hours on live chat widget even if all the agents are offline. Outside available hours visitors can be warned with a message and a pre-chat form.",
      "DAY": {
        "ENABLE": "Activați disponibilitatea pentru această zi",
        "UNAVAILABLE": "Indisponibil",
        "HOURS": "ore",
        "VALIDATION_ERROR": "Ora de începere ar trebui să fie înainte de ora închiderii.",
        "CHOOSE": "Alege"
      },
      "ALL_DAY": "Toată ziua",
      "SAVE_TO_ALL": "Salvează pentru toate inbox-urile",
      "SAVE_TO_ALL_TITLE": "Copiază programul de lucru",
      "SAVE_TO_ALL_CONFIRM": "Setările din acest formular (comutator de disponibilitate, mesaj de absență, fus orar și program de lucru) vor fi copiate în toate celelalte inbox-uri, cu excepția inbox-urilor de email și telefon. Sigur doriți să continuați?",
      "SAVE_TO_ALL_CANCEL": "Anulează",
      "SAVE_TO_ALL_YES": "Da, copiază pentru toate",
      "SAVE_TO_ALL_SUCCESS": "Programul de lucru a fost copiat cu succes în toate celelalte inbox-uri",
      "SAVE_TO_ALL_ERROR": "Copierea programului de lucru în alte inbox-uri a eșuat"
    },
    "PHONE": {
      "TITLE": "Setări telefon",
      "SUBTITLE": "Configurați ce apeluri vor apărea sub acest inbox.",
      "UPDATE": "Salvează setările",
      "EDIT": {
        "SUCCESS_MESSAGE": "Setările de telefon au fost actualizate",
        "ERROR_MESSAGE": "Actualizarea setărilor de telefon a eșuat"
      },
      "PHONE_NUMBERS": {
        "LABEL": "Numere de telefon",
        "SUBTITLE": "Introduceți numerele de telefon care aparțin acestui inbox.",
        "PLACEHOLDER": "+145123908635",
        "ADD": "Adaugă un număr de telefon"
      }
    },
    "IMAP": {
      "TITLE": "IMAP",
      "SUBTITLE": "Setarea detaliilor IMAP",
      "NOTE_TEXT": "Pentru a activa SMTP, vă rugăm să configurați IMAP.",
      "UPDATE": "Actualizarea setărilor IMAP",
      "TOGGLE_AVAILABILITY": "Activarea configurației IMAP pentru acest inbox",
      "TOGGLE_HELP": "Enabling IMAP will help the user to receive email",
      "EDIT": {
        "SUCCESS_MESSAGE": "Setările IMAP actualizate cu succes",
        "ERROR_MESSAGE": "Imposibil de actualizat setările IMAP"
      },
      "ADDRESS": {
        "LABEL": "Adresa",
        "PLACE_HOLDER": "Adresa (De exemplu: imap.gmail.com)"
      },
      "PORT": {
        "LABEL": "Port",
        "PLACE_HOLDER": "Port"
      },
      "LOGIN": {
        "LABEL": "Conectează-te",
        "PLACE_HOLDER": "Conectează-te"
      },
      "PASSWORD": {
        "LABEL": "Parola",
        "PLACE_HOLDER": "Parola"
      },
      "ENABLE_SSL": "Activare SSL"
    },
    "MICROSOFT": {
      "TITLE": "Microsoft",
      "SUBTITLE": "Reautorizarea contului MICROSOFT"
    },
    "SMTP": {
      "TITLE": "SMTP",
      "SUBTITLE": "Setarea detaliilor SMTP",
      "UPDATE": "Actualizarea setărilor SMTP",
      "TOGGLE_AVAILABILITY": "Activați configurația SMTP pentru acest inbox",
      "TOGGLE_HELP": "Activarea SMTP va ajuta utilizatorul să trimită e-mailuri",
      "EDIT": {
        "SUCCESS_MESSAGE": "Setările SMTP actualizate cu succes",
        "ERROR_MESSAGE": "Imposibil de actualizat setările SMTP"
      },
      "ADDRESS": {
        "LABEL": "Adresa",
        "PLACE_HOLDER": "Adresă (De exemplu: smtp.gmail.com)"
      },
      "PORT": {
        "LABEL": "Port",
        "PLACE_HOLDER": "Port"
      },
      "LOGIN": {
        "LABEL": "Conectează-te",
        "PLACE_HOLDER": "Conectează-te"
      },
      "PASSWORD": {
        "LABEL": "Parola",
        "PLACE_HOLDER": "Parola"
      },
      "DOMAIN": {
        "LABEL": "Domeniu",
        "PLACE_HOLDER": "Domeniu"
      },
      "ENCRYPTION": "Criptare",
      "SSL_TLS": "SSL/TLS",
      "START_TLS": "STARTTL-URI",
      "OPEN_SSL_VERIFY_MODE": "Deschideți modul de verificare SSL",
      "AUTH_MECHANISM": "Autentificare"
    },
    "EMAIL_DNS_CHECK": {
      "TITLE": "Livrabilitatea e-mailurilor (DNS)",
      "SUB_TITLE": "Verificăm în fiecare zi lucrătoare înregistrările SPF, DKIM, DMARC și MX ale domeniului {domain}. Când ceva face ca serverele care primesc mesajele să respingă răspunsurile dumneavoastră sau să le trimită în spam, administratorii primesc un e-mail cu soluția.",
      "RUN": "Rulați verificarea",
      "RUN_SUCCESS": "Verificarea DNS s-a încheiat",
      "RUN_ERROR": "Verificarea DNS nu a putut fi rulată, încercați din nou",
      "NOT_CHECKED": "Încă nu a fost verificat.",
      "CHECKED_AT": "Ultima verificare: {time}.",
      "DNS_UNAVAILABLE": "La ultima verificare, serverele de nume ale domeniului nu au răspuns. Rezultatul de mai jos provine din verificarea anterioară.",
      "SENDER": {
        "SMTP": "Răspunsurile sunt trimise prin {host}.",
        "PLATFORM": "Răspunsurile sunt trimise prin serverele noastre de e-mail."
      },
      "STATUS": {
        "OK": "Toate înregistrările sunt în regulă",
        "WARNING": "Unele înregistrări ar putea fi mai bune",
        "ERROR": "Răspunsurile ar putea să nu ajungă la destinatari",
        "UNKNOWN": "Necunoscut"
      },
      "SEVERITY": {
        "ERROR": "Problemă",
        "WARNING": "Avertisment"
      },
      "FIX": "Remediați cu această înregistrare DNS:",
      "RECORD_TYPE": "Tip",
      "RECORD_HOST": "Nume",
      "RECORD_VALUE": "Valoare",
      "ISSUES": {
        "spf_missing": {
          "TITLE": "Lipsește înregistrarea SPF",
          "DESCRIPTION": "Domeniul nu precizează ce servere au voie să trimită e-mailuri în numele lui. Multe servere de e-mail tratează atunci răspunsurile dumneavoastră drept spam. Adăugați o înregistrare SPF care să permită {sender}."
        },
        "spf_multiple": {
          "TITLE": "Domeniul are {count} înregistrări SPF",
          "DESCRIPTION": "Un domeniu poate avea o singură înregistrare SPF. Dacă sunt mai multe, serverele care primesc mesajele ignoră SPF și deseori resping e-mailul. Îmbinați-le într-o singură înregistrare."
        },
        "spf_not_authorized": {
          "TITLE": "SPF nu permite serverul care trimite răspunsurile dumneavoastră",
          "DESCRIPTION": "Răspunsurile dumneavoastră sunt trimise prin {sender}, dar înregistrarea SPF a domeniului nu îl include. Înregistrarea actuală: {record}"
        },
        "spf_too_many_lookups": {
          "TITLE": "Înregistrarea SPF necesită prea multe interogări DNS",
          "DESCRIPTION": "Serverele care primesc mesajele nu mai verifică SPF după {limit} interogări DNS, însă {sender}, prin care sunt trimise răspunsurile dumneavoastră, este atins abia după {lookups}. Răspunsurile dumneavoastră nu trec de SPF. Mutați {sender} la începutul înregistrării și eliminați valorile include pe care domeniul nu le mai folosește."
        },
        "spf_lookups_others": {
          "TITLE": "Unii expeditori din înregistrarea SPF depășesc limita de interogări",
          "DESCRIPTION": "Înregistrarea SPF necesită {lookups} interogări DNS, iar serverele care primesc mesajele se opresc după {limit}. Răspunsurile dumneavoastră sunt identificate la timp și trec, dar e-mailurile de la acești expeditori nu trec de SPF: {senders}. Eliminați valorile include pe care domeniul nu le mai folosește."
        },
        "spf_malformed": {
          "TITLE": "Înregistrarea SPF este defectă",
          "DESCRIPTION": "Serverele care primesc mesajele nu pot citi înregistrarea SPF a domeniului, așa că aceasta nu vă protejează răspunsurile. Problema se află în: {terms}. Înlocuiți înregistrarea cu cea corectată."
        },
        "dkim_missing": {
          "TITLE": "Semnătura DKIM nu este configurată",
          "DESCRIPTION": "Nu am găsit nicio cheie DKIM la {selectors}. Fără ea, răspunsurile dumneavoastră nu sunt semnate și ajung mai ușor în spam. Activați semnarea DKIM pentru domeniu la furnizorul dumneavoastră de e-mail."
        },
        "dmarc_missing": {
          "TITLE": "Lipsește înregistrarea DMARC",
          "DESCRIPTION": "Furnizorii mari de e-mail, precum Gmail și Microsoft, așteaptă o înregistrare DMARC. Fără ea, răspunsurile dumneavoastră ajung mai ușor în spam."
        },
        "dmarc_fails": {
          "TITLE": "DMARC cere destinatarilor să respingă răspunsurile dumneavoastră",
          "DESCRIPTION": "Politica DMARC a domeniului este „{policy}”, iar răspunsurile dumneavoastră nu trec nici de SPF, nici de DKIM, așa că destinatarii le resping sau le mută în spam. Remediați SPF și DKIM de mai sus."
        },
        "dmarc_blocks_platform": {
          "TITLE": "DMARC blochează răspunsurile trimise prin serverele noastre de e-mail",
          "DESCRIPTION": "Această căsuță trimite răspunsurile prin serverele noastre de e-mail, dar politica DMARC a domeniului este „{policy}”, așa că destinatarii le resping sau le mută în spam. Configurați SMTP-ul propriului server de e-mail pentru această căsuță."
        },
        "mx_missing": {
          "TITLE": "Domeniul nu are înregistrare MX",
          "DESCRIPTION": "Fără o înregistrare MX nimeni nu poate trimite e-mailuri către domeniu, deci clienții nu pot răspunde la mesajele dumneavoastră."
        }
      }
    },
    "NOTE": "Observație: ",
    "WIDGET_BUILDER": {
      "WIDGET_OPTIONS": {
        "AVATAR": {
          "LABEL": "Avatar site-ul web",
          "DELETE": {
            "API": {
              "SUCCESS_MESSAGE": "Avatar șters cu succes",
              "ERROR_MESSAGE": "A apărut o eroare, încercați din nou"
            }
          }
        },
        "WEBSITE_NAME": {
          "LABEL": "Nume website",
          "PLACE_HOLDER": "Introduceți numele website-ului dvs. (de exemplu: Acme Inc)",
          "ERROR": "Vă rugăm să introduceți un nume valid al site-ului web"
        },
        "WELCOME_HEADING": {
          "LABEL": "Titlu de salut",
          "PLACE_HOLDER": "Bună!"
        },
        "WELCOME_TAGLINE": {
          "LABEL": "Tagline de Bun Venit",
          "PLACE_HOLDER": "Noi facem conectarea cu noi simplă. Întreabă-ne orice, sau partajează-ți feedback-ul."
        },
        "REPLY_TIME": {
          "LABEL": "Timp de răspuns",
          "IN_A_FEW_MINUTES": "În câteva minute",
          "IN_A_FEW_HOURS": "În câteva ore",
          "IN_A_DAY": "Într-o zi"
        },
        "WIDGET_COLOR_LABEL": "Culoare widget",
        "WIDGET_BUBBLE_POSITION_LABEL": "Widget Bubble Poziția",
        "UNREAD_MESSAGES_MAX_HEIGHT": {
          "LABEL": "Înălțimea maximă a mesajelor necitite (px)",
          "PLACE_HOLDER": "Fără limită",
          "HELP_TEXT": "Limitați înălțimea maximă a ferestrei pop-up cu mesaje necitite în pixeli. Lăsați gol pentru comportamentul implicit (fără limită)."
        },
        "WIDGET_BUBBLE_TYPE_LABEL": "Widget Bubble Tip",
        "WIDGET_BUBBLE_LAUNCHER_TITLE": {
          "DEFAULT": "Discută cu noi",
          "LABEL": "Widget Bubble Launcher Titlu",
          "PLACE_HOLDER": "Discută cu noi"
        },
        "UPDATE": {
          "BUTTON_TEXT": "Actualizați setările",
          "API": {
            "SUCCESS_MESSAGE": "Setările widget-ului actualizate cu succes",
            "ERROR_MESSAGE": "Imposibil de actualizat setările IMAP"
          }
        },
        "WIDGET_VIEW_OPTION": {
          "PREVIEW": "Previzualizați",
          "SCRIPT": "Script Messenger"
        },
        "WIDGET_BUBBLE_POSITION": {
          "LEFT": "Stânga",
          "RIGHT": "Dreapta"
        },
        "WIDGET_BUBBLE_TYPE": {
          "STANDARD": "Standard",
          "EXPANDED_BUBBLE": "Bubble extins"
        }
      },
      "WIDGET_SCREEN": {
        "DEFAULT": "Implicit",
        "CHAT": "Chat"
      },
      "REPLY_TIME": {
        "IN_A_FEW_MINUTES": "De obicei, răspunsurile în câteva minute",
        "IN_A_FEW_HOURS": "De obicei, răspunsurile în câteva ore",
        "IN_A_DAY": "De obicei, răspunsurile într-o zi"
      },
      "FOOTER": {
        "START_CONVERSATION_BUTTON_TEXT": "Începe conversația",
        "CHAT_INPUT_PLACEHOLDER": "Scrie mesajul tău"
      },
      "BODY": {
        "TEAM_AVAILABILITY": {
          "ONLINE": "Suntem online",
          "OFFLINE": "Suntem plecați în acest moment"
        },
        "USER_MESSAGE": "Salut",
        "AGENT_MESSAGE": "Bună"
      },
      "BRANDING_TEXT": "Oferit de JARABOT",
      "SCRIPT_SETTINGS": "\nwindow.jarabotSettings = {options};"
    },
    "EMAIL_PROVIDERS": {
      "MICROSOFT": "Microsoft",
      "GOOGLE": "Google",
      "OTHER_PROVIDERS": "Alți furnizori"
    },
    "CHANNELS": {
      "MESSENGER": "Messenger",
      "WEB_WIDGET": "Site web",
      "TWITTER_PROFILE": "Twitter",
      "TWILIO_SMS": "Twilio SMS",
      "WHATSAPP": "WhatsApp",
      "SMS": "SMS",
      "SMS_BRANA": "SMS Brana",
      "DIDWW": "DIDWW",
      "EMAIL": "E-mail",
      "TELEGRAM": "Telegram",
      "LINE": "Line",
      "API": "Canal API",
      "PHONE": "Telefon SIP",
      "INSTAGRAM": "Instagram",
      "SALESFORCE": "Salesforce",
      "ALLEGRO": "Allegro",
      "KAUFLAND": "Kaufland"
    }
  }
}
